export default __webpack_public_path__ + "static/media/signInBg.d6ee9d55.png";